












import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'CommonContent',
  props: {
    normalTextList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
});
